import { render } from "./Modal.vue?vue&type=template&id=016ef8d8&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=016ef8d8&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-016ef8d8"
/* custom blocks */
import block0 from "./Modal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script